/* eslint-disable camelcase */

// Auto-generated at build time. Run: ts-node ./libs/core/base/scripts/fetch-installments-config

export const installmentsConfig = {
  minimum_installments_months: 3,
  maximum_installments_months: 12,
}
